/**
 * ELISEE CORE - Shopify Integration
 * Inietta le logiche avanzate della PWA (Intelligenza, Toast, Konami, A/B Test) nel tema Shopify
 */
document.addEventListener('DOMContentLoaded', () => {
  
  // ==========================================
  // 1. SISTEMA TOAST NOTIFICATIONS
  // ==========================================
  const toastEl = document.createElement('div');
  toastEl.className = 'elisee-toast';
  document.body.appendChild(toastEl);
  
  let toastTimer;
  window.eliseeToast = (msg) => {
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('show'), 3000);
  };

  // ==========================================
  // 2. INTELLIGENZA - SALUTI CONTESTUALI
  // ==========================================
  const hour = new Date().getHours();
  let timeStr = 'Benvenuto';
  if (hour < 12) timeStr = 'Buongiorno';
  else if (hour < 18) timeStr = 'Buon pomeriggio';
  else timeStr = 'Buonasera';

  // Cerchiamo i titoli principali della Homepage (h1/h2 nei banner)
  const heroTitles = document.querySelectorAll('.banner__heading, .hero__title');
  heroTitles.forEach(el => {
    if (!el.dataset.personalized) {
      el.dataset.personalized = "true";
      // Mantieni lo stile del tema ma inietta il saluto
      el.innerHTML = `<span style="font-size: 0.6em; opacity: 0.9; display:block; margin-bottom: 10px;">${timeStr},</span>${el.innerHTML}`;
    }
  });

  // ==========================================
  // 3. A/B TESTING ENGINE NATIVO
  // ==========================================
  let abVariant = localStorage.getItem('elisee_ab_cta');
  if (!abVariant) {
    abVariant = Math.random() < 0.5 ? 'a' : 'b';
    localStorage.setItem('elisee_ab_cta', abVariant);
  }
  
  const ctas = document.querySelectorAll('.banner__buttons a.button, .hero__btn');
  ctas.forEach(cta => {
    // Variante A = "Scopri la Collezione" (Più descrittivo)
    // Variante B = "Shop Now" (Più diretto)
    const originalText = cta.textContent;
    if (abVariant === 'a') cta.textContent = 'Scopri la Collezione';
    else cta.textContent = 'Shop Now';
    
    cta.addEventListener('click', () => {
      localStorage.setItem('elisee_ab_conversion', abVariant);
    });
  });

  // ==========================================
  // 4. TRACKING E METRICHE (LOCALI)
  // ==========================================
  let visits = parseInt(localStorage.getItem('elisee_visits') || '0');
  localStorage.setItem('elisee_visits', visits + 1);

  // Intercettiamo l'Aggiunta al Carrello per mostrare i Toast invece dei lenti alert nativi
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
  addToCartForms.forEach(form => {
    form.addEventListener('submit', () => {
      window.eliseeToast('Prodotto aggiunto al carrello! 🛍️');
    });
  });

  // ==========================================
  // 5. PANNELLO SEGRETO DIREZIONE (KONAMI CODE)
  // ==========================================
  const KONAMI = ['ArrowUp','ArrowUp','ArrowDown','ArrowDown','ArrowLeft','ArrowRight','ArrowLeft','ArrowRight','b','a'];
  let kIdx = 0;
  
  document.addEventListener('keydown', e => {
    if (e.key === KONAMI[kIdx]) {
      kIdx++;
      if (kIdx === KONAMI.length) {
        kIdx = 0;
        openPowerPanel();
      }
    } else {
      kIdx = 0;
    }
  });

  function openPowerPanel() {
    let pp = document.getElementById('elisee-power-panel');
    if (!pp) {
      pp = document.createElement('div');
      pp.id = 'elisee-power-panel';
      pp.className = 'elisee-power-panel active';
      
      const conv = localStorage.getItem('elisee_ab_conversion') || 'Nessuna';
      
      pp.innerHTML = `
        <div class="epp-title">⚡ ELISEE POWER PANEL ⚡</div>
        <div class="epp-row"><span>Sito</span><span class="epp-val">Shopify Live</span></div>
        <div class="epp-row"><span>Visite Totali Utente</span><span class="epp-val">${visits + 1}</span></div>
        <div class="epp-row"><span>A/B Test Assegnato (CTA)</span><span class="epp-val">Variante ${abVariant.toUpperCase()}</span></div>
        <div class="epp-row"><span>Conversione A/B Test</span><span class="epp-val">${conv.toUpperCase()}</span></div>
        <div class="epp-row"><span>User Agent</span><span class="epp-val" style="font-size:10px; max-width:60%; text-align:right;">${navigator.userAgent}</span></div>
        <button class="epp-close" onclick="document.getElementById('elisee-power-panel').classList.remove('active')">Chiudi Pannello</button>
      `;
      document.body.appendChild(pp);
    } else {
      pp.classList.add('active');
    }
    window.eliseeToast('Area Direzione Sbloccata 🔒');
  }

  // API Globale
  window.EliseeCore = {
    version: '2.0.0',
    toast: window.eliseeToast,
    openAdmin: openPowerPanel
  };

});
